import ABusiness from './views/a-business.c';
export default ABusiness;
